import { render, staticRenderFns } from "./CarterMetricsUtilisation.vue?vue&type=template&id=38ff0b5a&"
import script from "./CarterMetricsUtilisation.vue?vue&type=script&lang=ts&"
export * from "./CarterMetricsUtilisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports